export default __webpack_public_path__ + "static/media/morten.5b0a49b7.jpg";